import { ExposureDirectionType } from 'data/types';

export const LOCATION_BOX_CLASSES =
  'absolute flex items-center justify-center gap-1 rounded border-2 border-blue-400 bg-blue-100/80 p-2 text-sm font-medium text-blue-900 transition-all cursor-pointer pointer-events-auto hover:bg-blue-200/90 hover:border-blue-500';

export function getSideLabel(direction: ExposureDirectionType): string {
  return `${direction} Side`;
}
